import { Component, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Utility } from '../../../common/utility';
import { DialogService } from './../../../shared/services/dialog.service';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Page } from '../../../models/list/page.model';
import { DiseaseModel } from '../../../models/consultation-process/disease.model';
import { GroupRecommendedDiseaseService } from './group-recommended-disease.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { ConsultationProcessService } from '../consultation-process.service';
import { NewDiseasePopupComponent } from '../select-disease/new-disease-popup.component';
import { GroupConsultationStep } from '../../../models/consultation/consultation.model';

@Component({
  templateUrl: 'group-recommended-disease.component.html',
  providers: [GroupRecommendedDiseaseService]
})

export class GroupRecommendedDiseaseComponent extends BaseConsultationComponent implements OnInit {
  public subscription: Subscription;
  public page = new Page();
  public dataRow = new Array<DiseaseModel>();

  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total // Footer total message
  };
  public customClasses = AppConstants.table.footerClasses;
  public appConstants = AppConstants;
  constructor(
    public dialogService: DialogService,
    public utility: Utility,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    private groupRecommendedDiseaseService: GroupRecommendedDiseaseService) {
    super(dialogService, consultationProcessService, router, activeRouter, GroupConsultationStep.RecommendedDiseases, true);
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
    this.initTripInfoGroup();
  }

  setPage(pageInfo) {
    this.groupRecommendedDiseaseService.getDiseaseList(this.filterParam.id).subscribe(result => {
      if (result) {
        const data = result.json();
        this.dataRow = data;
      }
    });
    this.page.totalElements = this.dataRow.length;
  }

  getListDiseaseId(): Array<any> {
    let i = 0;
    const arr = [];
    while (i < this.dataRow.length) {
      arr.push(this.dataRow[i].id);
      i++;
    }
    return arr;
  }

  onAddNewDiseaseDialog() {
    const data = {
      consultationId: this.filterParam.id,
      isGroup: true,
      listDiseaseId: this.getListDiseaseId()
    };
    // just add to table DON'T CALL API
    this.dialogService.openComponentDialog(NewDiseasePopupComponent, data, {
      'width': '450px', position:
        { top: this.getTopPosition() + 'px' }
    }).subscribe(result => {
      if (result) {
        const newDisease = result.map(d => {
          return {
            id: d.id,
            name: d.name,
            isGroupRecommendation: false
          };
        });
        // this.groupRecommendedDiseaseService.addNewDisease(this.filterParam.id, result).subscribe(resultAdd => {
        //   if (resultAdd) {
        //     this.setPage({ offset: 0 });
        //   }
        // });
        this.dataRow = this.dataRow.concat(newDisease);
      }
    });
  }

  onRemoveItem(id: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.disease.removeDisease }).subscribe(result => {
      if (result) {
        // remove user
        this.groupRecommendedDiseaseService.removeDisease(this.filterParam.id, id).subscribe(
          (resultRemove) => {
            if (resultRemove) {
              // this.setPage({ offset: 0 });
              const index = this.dataRow.findIndex(x => x.id === id);
              if (index > - 1) {
                this.dataRow.splice(index, 1);
              }
            }
          }
        );
      }
    });
  }

  /**
   * over write from BaseConsultationComponent
   * submit step data
   */
  submitData() {
    //call API to submit
    const param = this.dataRow;//.filter(d => d.isGroupRecommendation);
    this.groupRecommendedDiseaseService.updateDisease(this.filterParam.id, param, this.isMoveNextStep).subscribe(
      (result) => {
        // move to another step
        this.navigateAction();
      }
    );
  }

  /**
     * over write from BaseConsultationComponent
     * this function will be called when user click on breakscrum step or next, prev button
     */
  changeConsultationStep() {
    this.submitData();
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/group-recommended-disease/group-recommended-disease.component.ts